/* ═══ AgSpinner — Anagogia Design System ═══ */

import { AG_LABELS } from '../utils/agLabels';

import styles from './AgSpinner.module.css';

interface AgSpinnerProps {
  /** Spinner diameter: sm=16px, md=24px, lg=40px */
  size?: 'sm' | 'md' | 'lg';
  /** Stroke color source */
  color?: 'primary' | 'inherit' | 'white';
  className?: string;
}

const STROKE_WIDTHS: Record<string, number> = {
  sm: 3,
  md: 3,
  lg: 4,
};

/**
 * Indicateur de chargement circulaire.
 * @category Feedback
 */
function AgSpinner({
  size = 'md',
  color = 'primary',
  className,
}: AgSpinnerProps) {
  const colorClass =
    color === 'primary'
      ? styles.colorPrimary
      : color === 'white'
        ? styles.colorWhite
        : styles.colorInherit;

  const strokeWidth = STROKE_WIDTHS[size];
  const radius = 10;
  const circumference = 2 * Math.PI * radius;

  return (
    <span
      className={[styles.spinner, styles[size], colorClass, className]
        .filter(Boolean)
        .join(' ')}
      role="status"
      aria-label={AG_LABELS.chargement}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="12"
          cy="12"
          r={radius}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${circumference * 0.7} ${circumference * 0.3}`}
        />
      </svg>
    </span>
  );
}

export { AgSpinner };
export type { AgSpinnerProps };
export default AgSpinner;
